"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.passwordRules = void 0;
exports.passwordRules = [
    {
        validator: (v) => { var _a, _b; return ((_b = ((_a = v.match(/[a-z]/gu)) !== null && _a !== void 0 ? _a : '')) === null || _b === void 0 ? void 0 : _b.length) > 0; },
        errorMessage: 'Hasło musi zawierać przynajmniej 1 małą literę',
    },
    {
        validator: (v) => { var _a, _b; return ((_b = ((_a = v.match(/[A-Z]/gu)) !== null && _a !== void 0 ? _a : '')) === null || _b === void 0 ? void 0 : _b.length) > 0; },
        errorMessage: 'Hasło musi zawierać przynajmniej 1 wielką literę',
    },
    {
        validator: (v) => { var _a, _b; return ((_b = ((_a = v.match(/[0-9]/gu)) !== null && _a !== void 0 ? _a : '')) === null || _b === void 0 ? void 0 : _b.length) > 0; },
        errorMessage: 'Hasło musi zawierać przynajmniej 1 cyfrę',
    },
    {
        validator: (v) => v.length >= 8,
        errorMessage: 'Hasło musi mieć przynajmniej 8 znaków',
    },
];
